import type { ReactNode } from 'react';

type GhostButtonProps = {
  href: string;
  external?: boolean;
  children: ReactNode;
  className?: string;
  ariaLabel?: string;
};

const baseClasses = [
  'inline-block',
  'border',
  'border-[color:var(--color-accent)]',
  'bg-transparent',
  'text-[color:var(--color-foreground)]',
  'font-sans',
  'uppercase',
  'text-base',
  'tracking-[var(--tracking-button)]',
  'px-[37px]',
  'pt-[22px]',
  'pb-[20px]',
  'transition-colors',
  'hover:border-[color:var(--color-accent-hover)]',
  'focus-visible:border-[color:var(--color-accent-hover)]',
].join(' ');

export function GhostButton({ href, external, children, className, ariaLabel }: GhostButtonProps) {
  const externalAttrs = external ? { target: '_blank', rel: 'noopener noreferrer' } : {};

  return (
    <a
      href={href}
      aria-label={ariaLabel}
      className={className ? `${baseClasses} ${className}` : baseClasses}
      {...externalAttrs}
    >
      {children}
    </a>
  );
}
